/*
 * @Description: 
 * @Version: 2.0
 * @Autor: Seven
 * @Date: 2021-12-20 10:40:41
 * @LastEditors: Seven
 * @LastEditTime: 2022-01-24 10:43:54
 */
const routers = [{
	name: "firstPage",
	path: "firstPage",
	component: () => import("@/pages/firstPage.vue"),
	meta: {
		path: "/home/firstPage"
	}
}, {
	name: "change_theme",
	path: "changeTheme",
	component: () => import("@/pages/change_theme.vue"),
	meta: {
		path: "/home/changeTheme"
	}
}]
// 定义常量路由，
export default routers
